import { CityImprovementTypes } from '@colonist/game-states';
import styles from './UIGameCityImprovementTracker.module.scss';
import clsx from 'clsx';
import { UIGameCityImprovementTrackerColumn } from './UIGameCityImprovementTrackerColumn/UIGameCityImprovementTrackerColumn.tsx';
import React from 'react';
export function UIGameCityImprovementTracker({ cityImprovementState, className }) {
    const columns = [];
    const cityImprovementTypes = [
        CityImprovementTypes.Science,
        CityImprovementTypes.Trade,
        CityImprovementTypes.Politics
    ];
    for (const type of cityImprovementTypes){
        var _cityImprovementState_type, _cityImprovementState_type1;
        var _cityImprovementState_type_hasMetropolis, _cityImprovementState_type_level;
        columns.push(/*#__PURE__*/ React.createElement(UIGameCityImprovementTrackerColumn, {
            className: styles.column,
            cityImprovementType: type,
            hasMetropolis: (_cityImprovementState_type_hasMetropolis = (_cityImprovementState_type = cityImprovementState[type]) === null || _cityImprovementState_type === void 0 ? void 0 : _cityImprovementState_type.hasMetropolis) !== null && _cityImprovementState_type_hasMetropolis !== void 0 ? _cityImprovementState_type_hasMetropolis : false,
            key: type,
            level: (_cityImprovementState_type_level = (_cityImprovementState_type1 = cityImprovementState[type]) === null || _cityImprovementState_type1 === void 0 ? void 0 : _cityImprovementState_type1.level) !== null && _cityImprovementState_type_level !== void 0 ? _cityImprovementState_type_level : 0
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, columns);
}
